import { PriceLevel } from '@bytel/trilogy-react';

import { ListItemWithPrice } from './list-item-with-price';

export default function PlanPlusOptionHeader({ total }: Readonly<{ total: number }>) {
    return (
        <ListItemWithPrice
            mainTitle='À régler par mois'
            amount={total}
            className='has-text-white'
            period='mois'
            id='SummaryBox'
            priceLevel={PriceLevel.FIVE}
        />
    );
}
